import React from "react";
import { Typography } from "@mui/material";
import CustomDataGrid from "../../CustomDataGrid";
import { Box, Avatar } from "@mui/material";
import { red, green } from "@mui/material/colors";

const CuentaCorrienteTab = ({ dataRows }) => {
  const columnsObject = [
    { field: "fecha", headerName: "Fecha", flex: 1 },
    {
      field: "tipo_prev",
      headerName: "Cbte.",
      flex: 1,
      renderCell: (params) => {
        let color = ""; // Inicializamos el color por defecto
        let displayValue = params.value; // Valor que se mostrará dentro del Avatar
        // Asignar color según el valor de "tipo_prev"
        switch (params.value) {
          case "FB":
            color = "#f44336"; // Rojo 500
            break;
          case "RE":
            color = "#4caf50"; // Verde 500
            break;
          case "PR":
            color = "#2196f3"; // Azul 500
            break;
          default:
            color = "#9e9e9e"; // Gris si no coincide con los valores anteriores
            break;
        }

        return (
          <Avatar
            sx={{
              backgroundColor: color, // Color de fondo dependiendo de tipo_prev
              color: "white", // El color del texto dentro del Avatar será blanco
              width: 24, // Puedes ajustar el tamaño del Avatar
              height: 24, // Puedes ajustar el tamaño del Avatar
              fontSize: 12,
            }}
          >
            {displayValue}
          </Avatar>
        );
      },
    },
    { field: "id", headerName: "Id", flex: 1 },
    { field: "referencia", headerName: "Ref.", flex: 1 },
    { field: "presupuesto_id", headerName: "Pres.", flex: 1 },
    {
      field: "odontologo",
      headerName: "Odontólogo",
      flex: 2,
      textTransform: "capitalize",
    },
    { field: "importe_bruto", headerName: "I.Bruto", flex: 1 },
    { field: "porc_bonificacion", headerName: "Bonif.", flex: 0.5 },
    {
      field: "debe",
      headerName: "Debe",
      flex: 1.2,
      width: 120, // Establecer un ancho fijo para la columna
      renderCell: (params) => {
        // Convertimos el valor de texto a número
        let value = parseFloat(params.value) || 0; // Si es NaN, lo asignamos como 0

        // Si el valor es 0 o null, no mostrar nada
        if (value === 0 || value === null) {
          return <div></div>; // Retorna un div vacío si es 0 o null
        }

        // Formateamos el valor con separador de miles y 2 decimales
        const formattedValue = value.toLocaleString("es-AR", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });

        return (
          <div
            style={{
              textAlign: "right", // Alinea el texto a la derecha
              backgroundColor: "#f8d7da", // Rojo claro para el fondo
              color: "black", // Texto en negro
              padding: "8px", // Añadimos padding para mejorar la apariencia
              borderRadius: "6px", // Opcional: redondear las esquinas
              border: `1px solid ${red[500]}`,
            }}
          >
            {formattedValue}{" "}
            {/* Mostramos el valor con separador de miles y 2 decimales */}
          </div>
        );
      },
    },
    {
      field: "haber",
      headerName: "Haber",
      flex: 1.2,
      width: 120, // Establecer un ancho fijo para la columna
      renderCell: (params) => {
        // Convertimos el valor de texto a número
        let value = parseFloat(params.value) || 0; // Si es NaN, lo asignamos como 0

        // Si el valor es 0 o null, no mostrar nada
        if (value === 0 || value === null) {
          return <div></div>; // Retorna un div vacío si es 0 o null
        }

        // Formateamos el valor con separador de miles y 2 decimales
        const formattedValue = value.toLocaleString("es-AR", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });

        return (
          <div
            style={{
              textAlign: "right", // Alinea el texto a la derecha
              backgroundColor: "#d4edda", // Verde claro para el fondo
              color: "black", // Texto en negro
              padding: "8px", // Añadimos padding para mejorar la apariencia
              borderRadius: "6px", // Opcional: redondear las esquinas
              border: `1px solid ${green[500]}`,
            }}
          >
            {formattedValue}{" "}
            {/* Mostramos el valor con separador de miles y 2 decimales */}
          </div>
        );
      },
    },
    {
      field: "saldo",
      headerName: "Saldo",
      flex: 1.2,
      width: 120, // Establecer un ancho fijo para la columna
      renderCell: (params) => {
        // Convertimos el valor de texto a número
        let value = parseFloat(params.value) || 0; // Si es NaN, lo asignamos como 0

        // Si el valor es 0 o null, no mostrar nada
        if (value === 0 || value === null) {
          return <div></div>; // Retorna un div vacío si es 0 o null
        }

        // Formateamos el valor con separador de miles y 2 decimales
        const formattedValue = value.toLocaleString("es-AR", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });

        return (
          <div
            style={{
              textAlign: "right", // Alinea el texto a la derecha
              backgroundColor: "#f8d7da", // Rojo claro para el fondo
              color: "black", // Texto en negro
              padding: "8px", // Añadimos padding para mejorar la apariencia
              borderRadius: "6px", // Opcional: redondear las esquinas
              border: `1px solid ${red[500]}`,
            }}
          >
            {formattedValue}{" "}
            {/* Mostramos el valor con separador de miles y 2 decimales */}
          </div>
        );
      },
    },
  ];
  // Calcular la sumatoria de saldos
  const totalSaldo = dataRows
    .map((row) => parseFloat(row.saldo) || 0) // Convertimos saldo de string a número
    .reduce((acc, curr) => acc + curr, 0); // Sumamos todos los saldos
  // Formateamos el saldo total con separador de miles y dos decimales
  const formattedSaldo = totalSaldo.toLocaleString("es-AR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  return (
    <div>
      <Typography
        variant="h7"
        sx={{
          fontWeight: "bold", // Negrita para resaltar
          fontSize: "1.2rem", // Tamaño de fuente más grande
          color: "#2C3E50", // Un color más oscuro para un mejor contraste
          borderBottom: "2px solid #3498db", // Línea debajo para un toque visual
          paddingBottom: "8px", // Espaciado inferior
          textAlign: "center", // Alineación centrada para mayor visibilidad
          textShadow: "1px 1px 3px rgba(0, 0, 0, 0.2)", // Sombra para darle profundidad
          marginBottom: "16px", // Espacio debajo
        }}
      >
        Saldo Total: {formattedSaldo}
      </Typography>
      <Box sx={{ mt: 2 }}>
        <CustomDataGrid columnsObject={columnsObject} dataRows={dataRows} />
      </Box>
    </div>
  );
};

export default CuentaCorrienteTab;
